import { render, staticRenderFns } from "./Arquivos.vue?vue&type=template&id=93c5f344&scoped=true&"
import script from "./Arquivos.vue?vue&type=script&lang=js&"
export * from "./Arquivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c5f344",
  null
  
)

export default component.exports